module.exports = "<div class=\"marketingOffers {{className}}\" content >\n    <div ng-if=\"ad.backgroundImage\" class=\"prop-img\"></div>\n    <xo-title title-txt=\"{{ ad.Title }}\" tag-name=\"{{ xoTitleTag }}\" class-name=\"{{ xoTitleClass }}\"></xo-title>\n    <p class=\"subTitle\" ng-bind-html=\"ad.Body\"></p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-page-components/src/marketingOffers/template.html
// module id = ../node_modules/xo-page-components/src/marketingOffers/template.html
// module chunks = 0